<div class="block">
  <div class="bg-gray-100 p-2">
    <span class="font-bold">{{ data?.reference }}</span>
  </div>
  <div class="flex flex-col gap-2 p-2">
    <span>{{ data?.type }} - {{ data?.subject }}</span>
    <span class="flex flex-wrap gap-1">
      <ng-container *ngFor="let status of data?.statusses">
        <p-tag
          *ngIf="status?.name || status?.shortName"
          [style]="{
            background: status?.color
          }"
          class="flex"
          [pTooltip]="status?.name !== status?.shortName && status?.name"
          styleClass="overflow-hidden whitespace-nowrap w-full"
          tooltipPosition="top">
          <div class="flex items-center gap-2 overflow-hidden">
            <span
              [style]="{
                color: (status?.color | lightenDarkenColor) + ' !important'
              }"
              class="overflow-hidden text-ellipsis whitespace-nowrap"
              >{{ status?.shortName || status?.name }}</span
            >
            <i
              [style]="{
                color: (status?.color | lightenDarkenColor) + ' !important'
              }"
              class="{{ status.icon }}"></i>
          </div>
        </p-tag>
      </ng-container>
    </span>
  </div>
</div>
